<template>
  <div>
    <section class="intro bg-dark" :style="bg_image">
      <div class="container-fluid pt-3">
        <header>
          <div class="row justify-content-center align-content-center">
            <div class="col-5">
              <img :src="settings.logos.header_overlay" height="60" class="mt-2" />
            </div>
            <div class="col-7 text-right">
              <h1 class="main_title pr-3" v-html="$options.filters.translategrader(settings.copy.home_title, $i18n.locale)">Easy Grader<sup>®</sup></h1>
              <span class="header_networks" :class="$mq">
                <header-social-icons></header-social-icons>
              </span>
            </div>
            <div class="w-100"></div>
            <div class="col-md-12 ">

              <div class="title_box text-center">
                <div class="subtitle_heading">{{currentQuiz.title | translategrader($i18n.locale)}}</div>
                <div class="current_page" v-if="sectionCount > 1">{{currentPage}}</div>
              </div>
              <div class="w-100"></div>
              <div>
                <p class=" text-center quiz_description" v-html="applySmartquotes($options.filters.translategrader(currentQuiz.description, $i18n.locale))"></p>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div class="text-center scroll_down" @click="goToNextAnswer(-1, 10)">
        <img src="@/assets/img/down.svg" height="30" />
      </div>
    </section>

    <div class="position-sticky sticky-top menu_bar" :class="$mq">
      <div class="container-fluid">
        <header>
          <div class="row justify-content-center align-content-center">
            <div class="col-sm-4 sticky_logo" :class="$mq">
              <img :src="settings.logos.header_title" alt="Logo" height="58" >
            </div>
            <div class="col-sm-4 text-center">
              <div class="title_box2 text-center">
                <div class="subtitle_heading">{{currentQuiz.title | translategrader($i18n.locale)}}</div>
                <div class="current_page"  v-if="sectionCount > 1">{{currentPage}}</div>
              </div>
            </div>
            <div class="col-sm-4 text-right sticky_networks" :class="$mq">
              <h1 class="main_title pr-3" v-html="$options.filters.translategrader(settings.copy.home_title, $i18n.locale)">Easy Grader<sup>®</sup></h1>
              <header-social-icons></header-social-icons>
            </div>
          </div>
        </header>
      </div>
    </div>



    <main role="main" class="pattern" :style="bg_motif">

      <div class="question_panel" v-for="(question, questionIdx) in currentQuiz['questions']">
        <span class="question_anchor" :id="setDomQuestionId(questionIdx)">&nbsp;</span>

        <div class="next_chevron" :class="$mq">
          <img src="@/assets/img/previous.svg" height="15" @click="goToPreviousAnswer(questionIdx, 300)" class="pointer" v-if="questionIdx !== 0"/>
        </div>

        <quiz-element
          :action="updateAnswers"
          :question="question"
          :questionIdx="questionIdx"
          :questionsCount="questionsCount"
          :pageIdx="currentPage"
          :color="'#00f0af'"
          @answer-validated="goToNextAnswer(questionIdx)"
        >
        </quiz-element>

        <div class="next_chevron" :class="$mq" v-if="questionIdx !== currentQuiz['questions'].length-1">
          <img src="@/assets/img/next.svg" height="15" @click="goToNextAnswer(questionIdx, 300)" class="pointer"/>
        </div>
      </div>

    </main>

    <footer class="action_bar">
      <div class="progress" style="height: 10px;">
          <div
          class="progress-bar"
          role="progressbar"
          :style="progress_bar_style"
          :aria-valuenow="progressionPercent"
          aria-valuemin="0"
          aria-valuemax="100"></div>
      </div>
      <div class="d-flex flex-row">
        <div class="back_button"  @click="prevPage" :class="{hidden: hidePrev}">
          <img src="@/assets/img/puce.svg" height="20" style="transform: rotate(180deg); margin-left: 12px;margin-right: 20px;"/>
        </div>
        <div class="text-center flex-grow-1">
          <span>&nbsp;<!-- <a data-toggle="modal" data-target="#exampleModal" id="faire_pause" :class="$mq">{{ $t("front_end.faire_pause") }}</a> --></span>
        </div>
        <div class="text-right next_button pr-1 no_continue"
          @click="nextPage"
          v-if="hideNext"
          :data-balloon="textMissingQuestion"
           data-balloon-pos="left"
          >
          <span class="">{{ $t("front_end.continuer") }} <img src="@/assets/img/puce.svg" height="20" style="padding-left: 5px;"/></span>
        </div>
        <div class="text-right next_button pr-1 tada"
          @click="nextPage"
          v-if="!hideNext"
          >
          <span class="">{{ $t("front_end.continuer") }} <img src="@/assets/img/puce.svg" height="20" style="padding-left: 5px;"/></span>
        </div>
      </div>
    </footer>


<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ $t("front_end.pause_title") }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" v-html="$t('front_end.pause_body_text')">

        Vous pouvez quitter et reprendre ce diagnostic à tout moment, du moment que vous utilisez le même navigateur web. Il vous suffira de revenir sur la page d'accueil du diagnostic et de saisir à nouveau votre adresse email.<br /><br />

        Avertissement : si vous supprimez votre cache ou vos cookies, votre progression sera perdue.
      </div>
      <div class="modal-footer">
        <a class="btn btn-secondary" :href="$options.filters.translategrader(settings.brand.website_url, $i18n.locale)" target="_blank" v-if="$i18n.locale === 'fr'">{{$t('front_end.pause_exit')}}</a>
      </div>
    </div>
  </div>
</div>


  </div>
</template>

<script>


  import { mapActions, mapMutations, mapGetters } from 'vuex';

  import QuizElement from '@/components/QuizElement';
  import HeaderSocialIcons from '@/components/HeaderSocialIcons';

  import axios from 'axios';
  import { i18n } from '../plugins/i18n.js'
  import smartquotes from 'smartquotes';


  import {
    UPDATE_PROFILE
  } from '@/store/lead/mutations';

  export default {
    name: 'survey-question',

    components: {
      HeaderSocialIcons,
      QuizElement,
    },

    data() {
      return {
        loading: false,
        isValid: false,
        questionAnswered: [],
        isOverallProgress: true // true = overall progress, false = section progress
      }
    },

    mounted() {
      if (process.env.NODE_ENV !== 'development') {
        // No need of Zapier for the moment
        // this.alertOnZapier();
        //this.alertOnSlack();
        // Create hubspot form :
        //this.sendLeadToHubspot();
      }
      var first_missing_question = this.missingQuestions[0];
      if (typeof(first_missing_question) === "number") {
        this.goToNextAnswer(first_missing_question - 1, 2000);
      } else {
        this.goToNextAnswer(-1, 2000);
      }
    },

    watch:{
      $route (to, from){
        // we want to animate on introduction section on all page change
        var first_missing_question = this.missingQuestions[0];
        if (typeof(first_missing_question) === "number") {
          this.goToNextAnswer(first_missing_question - 1, 2000);
        } else {
          this.goToNextAnswer(-1, 2000);
        }
      }
    },


    computed: {
      ...mapGetters(
        {
          profile: 'lead/profile',
          docID: 'lead/docID',
          surveyObj: 'survey/survey',
          surveyID: 'survey/docID',
          quizList: 'quiz/list',
          settings: 'settings/settings'
        }
      ),

      // Styles
      bg_color: function(){
          var bgColor= this.currentQuiz.color;
          return {
            "background-color": bgColor,
          }
      },

      progress_bar_style: function(){
        var bgColor = "#00f0af";
        // var bgColor = this.currentQuiz.color;
        return {
          'width': this.progressionPercent+'%',
          "background-color": bgColor,
        }
      },

      bg_image: function() {
        var bg_url = this.currentQuiz.background_image;
        // var bg_url = process.env.VUE_APP_ROOT_FOLDER + "static/img/category_" + (this.currentPage) + ".jpg";
        return {
          "background-image": "url("+ bg_url +")"
        }
      },

      bg_motif: function() {
        var bg_url = process.env.VUE_APP_ROOT_FOLDER + "static/img/motifs/motif_"+ (this.currentPage) + ".png";
        return {
          "background-image": "url("+ bg_url +")"
        }
      },

      // Navigation

      currentPage() {
        return parseInt(this.$route.params.pageNumber) ;
      },

      currentQuiz() {
        return this.surveyObj.quizList[this.currentPage-1] ;
      },

      sectionCount(){
        return this.surveyObj.quizList.length;
      },

      questionsCount() {
        return this.surveyObj.quizList[this.currentPage-1].questions.length;
      },

      questionsCountOverall() {
        var counter = 0;
        for (var i = this.surveyObj.quizList.length - 1; i >= 0; i--) {
          counter += this.surveyObj.quizList[i].questions.length
        }
        return counter;
      },

      hidePrev() {
        return this.currentPage == 1;
      },

      hideNext() {
        // Hide next button if not all answers are answered
        var allAnswered = true;
        for (let question of this.surveyObj.quizList[this.currentPage-1].questions) {
          var answered = false;
          for (let answer of question.answers) {
            answered = answered || answer.checked;
          }
          allAnswered = allAnswered && answered;
        }
        return !allAnswered;
      },

      missingQuestions() {
        // human ID of missing questions
        var missingQuestionsArray = [];

        // for (const [question, question_index] of this.surveyObj.quizList[this.currentPage-1].questions.forEach) {
        this.surveyObj.quizList[this.currentPage-1].questions.forEach(function (question, question_index) {
          var answered = false;
          for (let answer of question.answers) {
            answered = answered || answer.checked;
          }
          if (!answered) {
            missingQuestionsArray.push(question_index)
          }
        });
        return missingQuestionsArray;
      },

      missingQuestionsOverall() {
        // human ID of missing questions
        var missingQuestionsArray = [];

        // for (const [question, question_index] of this.surveyObj.quizList[this.currentPage-1].questions.forEach) {
          for (var i = this.surveyObj.quizList.length - 1; i >= 0; i--) {
            this.surveyObj.quizList[i].questions.forEach(function (question, question_index) {
              var answered = false;
              for (let answer of question.answers) {
                answered = answered || answer.checked;
              }
              if (!answered) {
                missingQuestionsArray.push(question_index)
              }
            });
          };
          return missingQuestionsArray;
        },

      textMissingQuestion() {
        if (this.missingQuestions.length === 0) {
          return "";
        }
        else {
          return ( i18n.t('front_end.missing_question') + ' ' + (this.missingQuestions[0]+1));
        }
      },

      progressionPercent() {
        // isOverallProgress = true is we show the overall progresson
        // isOverallProgress = false is we show the section progresson
        if (this.isOverallProgress) {
          return (100 - 100 * this.missingQuestionsOverall.length / this.questionsCountOverall) ;
        } else {
          return (100 - 100 * this.missingQuestions.length / this.questionsCount) ;
        }

      }

    },

    methods: {
      ...mapMutations({
        updateProfile: 'lead/UPDATE_PROFILE',
        receiveSurveyID: 'survey/RESET_SURVEY_ID',
      }),

      ...mapActions(
      {
        createLead: 'lead/getOrCreateProfile',
        createSurvey: 'survey/getOrCreateSurvey',
      }),

      applySmartquotes(a) {
        a = smartquotes(a);
        a = a.replace(/\u201c/g, "\u00AB\&nbsp;");
        a = a.replace(/\u201d/g, "\&nbsp;\u00BB");
        a = a.replace(/(\w) \?/g, '$1&nbsp;?'); // add nb spaces before '?'
        return a;
      },

      setDomQuestionId(questionIdx) {
        return "question_" + questionIdx;
      },

      async updateAnswers() {
        console.log(this.currentQuiz);
      },

      prevPage() {
        if (this.currentPage == 1) {
          return;
        }
        else
        {
          var nextPage = this.currentPage - 1;
          this.$router.push({ name: 'Survey questions', params: { lang: this.$i18n.locale, pageNumber: nextPage }});
        }
      },

      nextPage() {
        if (this.missingQuestions.length === 0) {
          if (this.surveyObj.quizList.length == this.currentPage) {
            this.$router.push({ name: 'Additional Information', params: { lang: this.$i18n.locale }});
          }
          else
          {
            var nextPage = this.currentPage + 1;
            console.log("moving to :", '/questions/' + nextPage);
            this.$router.push({ name: 'Survey questions', params: { lang: this.$i18n.locale, pageNumber: nextPage }});
            // this.alertOnSlack();
          }
        } else {
          var first_missing_question = this.missingQuestions[0];
          if (typeof first_missing_question === "number" && first_missing_question > 1) {
            this.goToNextAnswer(first_missing_question-1, 0)
          }
        }
      },

      goToPreviousAnswer(questionIdx, delay = 500) {
        // Scroll down to next answer
        let nextQuestionDomId = "question_" + (questionIdx-1);

        this.questionAnswered.indexOf(questionIdx) === -1 ? this.questionAnswered.push(questionIdx) : console.log("This item already exists");

        if (questionIdx != 0) {

          var scroll_next_question = setInterval(function(){
            // Go to next field
            console.log("Going to next question", nextQuestionDomId);
            var nextField = document.getElementById(nextQuestionDomId);
            // console.log(nextField);
            try {
              nextField.scrollIntoView({ block: 'start',  behavior: 'smooth' });
              clearInterval(scroll_next_question);
            }
            catch(err) {
              clearInterval(scroll_next_question);
            }

          }, delay);
        }
        else {
          console.log("Not going to previous question because first question");
        }
      },

      goToNextAnswer(questionIdx, delay = 500) {
        var init_scroll = window.scrollY;
        // Scroll down to next answer
        let nextQuestionDomId = "question_" + (questionIdx+1);

        this.questionAnswered.indexOf(questionIdx) === -1 ? this.questionAnswered.push(questionIdx) : console.log("This item already exists");

        if (questionIdx != this.currentQuiz['questions'].length - 1) {

          var scroll_next_question = setInterval(function(){
            // Go to next field
            console.log("Going to next question", nextQuestionDomId);
            var nextField = document.getElementById(nextQuestionDomId);
            // console.log(nextField);
            var ready_scroll = window.scrollY;
            if (init_scroll === ready_scroll || ready_scroll === 0) {
              // We only move if user has not scroll in the meantime
              nextField.scrollIntoView({ block: 'start',  behavior: 'smooth' });
            } else {
              console.log("Not moving because already scrolled : ", init_scroll, ready_scroll);
            }
            clearInterval(scroll_next_question);
          }, delay);
        }
        else {
          console.log("Not going to next question because last question");
        }
      },

      async alertOnSlack() {

        // var currentPage = this.$route.params.pageNumber ;

        var slackUrl = "https://hooks.slack.com/services/special_setting";
        var payload={"text": "[Autodiag] Un lead parcourt en ce moment le formulaire.\nEmail : "
        + this.profile.email + "\n Survey : " + this.surveyID}
        try {
          await axios.post(slackUrl,
            JSON.stringify(payload), {
            withCredentials: false,
            transformRequest: [(data, headers) => {
              delete headers.post["Content-Type"] // See https://stackoverflow.com/a/49248026/2550237
              return data
            }]
          }
        )}
        catch (e) {
          console.log("Error while posting to Slack: ", e)
          // this.errors.push(e)
        }
      },

      async alertOnZapier() {

        var currentPage = this.$route.params.pageNumber ;

        var priorities = "";
        for (var prio of this.profile.priorities) {
          if (prio.checked) {
            if (priorities != "") {
              priorities += " - "
            }
            priorities += prio.name ;
          }
        }

        var apiUrl = "https://hooks.zapier.com/hooks/catch/special_Setting/";
        var payload={"profile": this.profile, "priorities": priorities}
        try {
          await axios.post(apiUrl,
            JSON.stringify(payload), {
            withCredentials: false,
            transformRequest: [(data, headers) => {
              delete headers.post["Content-Type"] // See https://stackoverflow.com/a/49248026/2550237
              return data
            }]
          }
        )}
        catch (e) {
          console.log("Error while posting to Zapier: ", e)
          // this.errors.push(e)
        }
      },

      getCookie (name) {  /// Retrieve cookie function
        var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) return match[1];
        return
      },

      async sendLeadToHubspot() {
        // Documentation : https://developers.hubspot.com/docs/methods/forms/submit_form_v3

        // We only send the email to hubspot this way on this page
        // Then, the rest is sent via Zapier on result page

        const hutk = this.getCookie("hubspotutk")
        const querystring = require('querystring');
        var apiUrl = "https://api.hsforms.com/submissions/v3/integration/submit/special_setting"

        var postData = {
            "fields":
            [
              {
                "name": "email",
                "value":  this.profile.email
              },
              {
                "name": "has_started_autodiag",
                "value":  true
              }
            ],
            'context': {
                "hutk": hutk,
                // "ipAddress": req.headers['x-forwarded-for'] || req.connection.remoteAddress,
                // "ipAddress": "120.12.12.192",
                "pageUri": "https://autodiag.okedito.com",
                "pageName": "Autodiag"
            },
            "skipValidation": true
        };


        try {
          await axios.post(apiUrl,
            JSON.stringify(postData), {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )}
        catch (e) {
          console.log("Error while posting to Hubspot: ", e)
          // this.errors.push(e)
        }
      }

    }
  }
</script>


<style scoped>

.intro {
  height: 100vh;
  background-size: cover;
  position: relative;
  z-index: 99;
  background-color: linear-gradient(to right bottom, #00f0af, #00e4d1, #00d4e9, #00c3f4, #00aff0);
}

.title_box {
  position: relative;
  width: 80vv;
  margin: 20vh auto 0 auto;
}

.title_box2 {
  position: relative;
}

.scroll_down{
  position: absolute;
  width: 30px;
  margin: 0 auto;
  left: calc(50% - 15px);
  bottom: 30px;
  cursor: pointer;

}

header p {
  color: #fff;
}

.main_title{
  color: #fff!important;
  font-size: 16px;
  padding-top: 45px;
  display: inline-block;
}

.intro .main_title {
  padding-top: 36px;
}

.social_share_link img{
  margin-top: -8px;
}

@media screen and (max-width: 1160px) {
  .main_title{
    font-size: 12px;
  }
}

.pattern {
  background-size: auto;
  background-repeat: repeat;
  background-color: #f3f3f3;
}

.question_anchor {
  position: absolute;
  top: -93px;
  left: 0 ;
}

.title_box .subtitle_heading {
  text-align: center;
  color: #ffffff;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 50px;
}

.title_box2 .subtitle_heading {
  text-align: center;
  color: #ffffff;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 20px;
  margin-top: 42px;
  line-height: 1.2em;
}

.quiz_description {
  font-family: 'Nunito', sans-serif;
  font-size: 20px;
}

.title_box .current_page {

  margin-top: -190px;
  margin-bottom: -50px;
  text-align: center;
  color: #ffffff;
  font-family: 'andale mono', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 200px;
  opacity: 0.3;
}
.title_box2 .current_page {
  margin-top: -58px;
  margin-bottom: 0px;
  text-align: center;
  color: #ffffff;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 60px;
  opacity: 0.3;
}

.submit_button {
  border-top-right-radius: 6px!important;
  border-bottom-right-radius: 6px!important;
  margin-left: -100%;
  z-index: 99;

}

.form-control {
  border-radius: 6px!important;
  border-top-right-radius: 6px!important;
  border-bottom-right-radius: 6px!important;
}

.question_panel {
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
}

.menu_bar {
  position: sticky;
  bottom: 0px;
  width: 100%;
  background-color: var(--colorPrimary);
  height: 112px;
  line-height: 92px;
  z-index: 1;
  border-bottom: 2px solid var(--colorSecondary);
}

.menu_bar.sm, .menu_bar.md, .menu_bar.lg {
  line-height: 92px;
}

.action_bar {
  position: sticky;
  bottom: 0px;
  width: 100%;
  background: var(--colorPrimary);
  color: #fff;
  /*height: 42px;*/
  line-height: 42px;
  z-index: 1;
  overflow-y: none;
}

.progress {
  border-radius: 0!important;
}

.action_bar .back_button {
  background-color: rgb(0,240,175);
  font-size: 18px;
  max-width: 42px;
  margin-right: calc(150px - 42px);
  cursor: pointer;
}

.action_bar .next_button {
  background-color: rgb(0,240,175);
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
  color: #051e41;
  max-width: 150px;
  cursor: pointer;
  padding-left: 10px;
}

.next_chevron {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
}

@media only screen and (max-width: 900px) {


  .title_box .subtitle_heading {
  }

  .title_box2 {
  }

  .title_box2 .subtitle_heading {
    margin-top: 45px;
    font-size: 16px;
  }
  .title_box2 .current_page {
  }

  .main_title {
    padding-top: 30px;
  }

}
@media only screen and (max-width: 480px) {


  .title_box .subtitle_heading {
    font-size: 30px;
  }

  .title_box2 {
    margin-top: 5px;
  }

  .title_box2 .subtitle_heading {
    font-size: 20px;
    line-height: 1em;
    margin-top: 20px;
  }
  .title_box2 .current_page {
    font-size: 50px;
    margin-top: -42px;
    margin-bottom: 0px;
  }

  .menu_bar {
    height: 64px;
    line-height: 64px!important;
  }

  .main_title {
    display: none;
  }

  .next_chevron{
    text-align: right;
    padding-right: 5px;
  }

  .question_anchor {
    position: absolute;
    top: -64px;
    left: 0 ;
  }
}


.tada {
  /* See http://waitanimate.wstone.io/#!/ */
  animation: tada_8620 3.0s linear infinite;
  transform-origin: 50% 50%;
}

@keyframes tada_8620 {
  0% { transform: scale(1) }
  5.55556% { transform:scale(.9) rotate(-8deg) }
  11.11111% { transform:scale(.9) rotate(-8deg) }
  16.66667% { transform:scale(1.3) rotate(8deg) }
  22.22222% { transform:scale(1.3) rotate(-8deg) }
  27.77778% { transform:scale(1.3) rotate(8deg) }
  33.33333% { transform:scale(1.3) rotate(-8deg) }
  38.88889% { transform:scale(1.3) rotate(8deg) }
  44.44444% { transform:scale(1) rotate(0) }
  100% { transform:scale(1) rotate(0) }
}

.action_bar a {
  color: #fff;
  text-decoration: underline;
}

.hidden {
  visibility: hidden;
}

.no_continue {
  background-color: rgba(0,240,175,.5)!important;
  /*pointer-events: none;*/
}

#faire_pause, .pointer {
  cursor: pointer;
}


/* Responsive rules */

.sticky_logo.sm, .sticky_networks.sm {
  display: none;
}

.sticky_networks.lg {
  line-height: 12px;
  padding-right: 20px;
}

.sticky_networks.lg .main_title {
  display: block;
  line-height: 12px;
  margin-top: 18px;
  padding-right: 0px !important;
}
.sticky_networks.lg .social_share_link {
  margin-right: 0px;
}
.sticky_networks.md .main_title {
  display: none;
}

.header_networks.sm {
  display: none
}

#faire_pause.sm {
  display: none;
}

.next_chevron.sm {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.next_chevron.sm img {
  height: 10px!important;
}

</style>



// WEBPACK FOOTER //
// src/pages/SurveyQuestion.vue